/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");
require("babel-polyfill");

window.Vue = require("vue");
import VeeValidate, { Validator } from "vee-validate";
import VueCookies from "vue-cookies";
import { saveAs } from "file-saver";
import JSZip from "jszip";
import route from "./route";

Vue.use(VueCookies);
Vue.use(VeeValidate, {
  events: "change",
});

// matomo tag manager analitics script
const analitycsConsented =
  VueCookies.get("analytics-consent") == null
    ? false
    : VueCookies.get("analytics-consent") == "true"
      ? true
      : false;
if (analitycsConsented) {
  // create script element and set attributes
  var _mtm = (window._mtm = window._mtm || []);
  _mtm.push({ "mtm.startTime": new Date().getTime(), event: "mtm.Start" });
  const scriptElement = document.createElement("script");
  scriptElement.setAttribute("type", "text/javascript");
  scriptElement.setAttribute(
    "src",
    "https://matomo.rokus-klett.si/js/container_VFwGKour.js",
  );
  document.head.prepend(scriptElement);

  // create noscript element and set attributes
  const noScriptElement = document.createElement("noscript");
  const iframeElement = document.createElement("iframe");
  iframeElement.setAttribute(
    "src",
    "https://matomo.rokus-klett.si/js/container_VFwGKour.js",
  );
  iframeElement.setAttribute("height", "0");
  iframeElement.setAttribute("width", "0");
  iframeElement.setAttribute("style", "display:none;visibility:hidden");
  noScriptElement.appendChild(iframeElement);
  document.body.prepend(noScriptElement);
}

const dictionary = {
  messages: {
    required: "Podatek je obvezen.",
  },
  custom: {
    user_agreement: {
      required: "Strinjati se morate s pogoji uporabe in nakupa.",
    },
  },
};
Validator.localize("sl", dictionary);

Vue.component("i-zbirka", require("./components/IZbirka.vue"));
Vue.component("i-zbirka-add", require("./components/IZbirkaAdd.vue"));
Vue.component("has-flash", require("./components/HasFlash.vue"));
Vue.component("activation-code", require("./components/ActivationCode.vue"));
Vue.component("free-packages", require("./components/FreePackages.vue"));
Vue.component("buy-packages", require("./components/BuyPackages.vue"));
Vue.component(
  "buy-packages-confirmation",
  require("./components/BuyPackagesConfirmation.vue"),
);
Vue.component("popup-stack", require("./modals/PopupStack.vue"));
Vue.component("cookie-consent", require("./components/CookieConsent.vue"));
Vue.component(
  "cookie-consent-details",
  require("./components/CookieConsentDetails.vue"),
);
Vue.component("recordings", require("./components/Recordings.vue"));
Vue.component(
  "additional-content",
  require("./components/AdditionalContent.vue"),
);
Vue.component("news", require("./components/News.vue"));
Vue.component("news-single", require("./components/NewsSingle.vue"));
Vue.component("dropdown", require("./components/Dropdown.vue"));
Vue.component("glasovanja", require("./components/Glasovanja.vue"));
Vue.component(
  "glasovanja-rezultati",
  require("./components/Glasovanja-rezultati.vue"),
);

Vue.component("ui-embed", require("./components/UiEmbed.vue"));
Vue.component("ui-popup", require("./components/UiPopup.vue"));
Vue.component("mp-video", require("./components/MpVideo.vue"));

import popupAkademija from "./modals/PopupAkademija.vue";
import popupRokus360 from "./modals/PopupRokus360.vue";

Vue.mixin({
  methods: {
    route,
    saveAs,
    JSZip,
  },
});

Vue.filter("formatPrice", function (value) {
  return value.toFixed(2).replace(".", ",") + " EUR";
});

const app = new Vue({
  el: "#app",
  mounted() {
    // check if popups are consented
    const popupConsented =
      this.$cookies.get("site-popup-consent") == null
        ? false
        : this.$cookies.get("site-popup-consent") == "true"
          ? true
          : false;
    if (popupConsented) {
      // this.$root.$emit('add-popup', popupIzzi);

      axios.get(this.route("status")).then(
        (response) => {
          if (response.data.status == "teacher") {
            if (response.data.statusId) {
              window.user = response.data.statusId.id;
            }
            // this.$nextTick(() => {
            // 	this.$root.$emit('add-popup', popupAkademija);
            // })
          }
        },
        (reason) => {
          console.error(reason);
        },
      );
    }
    // check for videos on uporabniki priporocajo page
    const videoContainers = document.getElementsByClassName(
      "play-uporabniki-priporocajo",
    );
    if (videoContainers.length) {
      // mount component to each video container
      for (let i = 0; i < videoContainers.length; i++) {
        const num = i;
        const videoTitle = videoContainers[num].getAttribute("data-video");
        new this.$options.components["mp-video"]({
          propsData: {
            videoTitle: videoTitle,
          },
        }).$mount(videoContainers[num]);
      }
    }

    this.$root.$emit("add-popup", popupRokus360);
  },
  methods: {
    showConsent() {
      this.$root.$emit("show-consent");
    },
  },
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js